import * as parent from '../variables';
import { IS_ADMIN } from '../../constants/validation';

export const colors = {
  ...parent.colors,
  // Common properties (same for both admin and non-admin)
  HEADER_COUNT_TEXT: '#fff',
  GREY: '#999',
  DAILY_LOG_GRAPH_BORDER: '#919191',
  MODAL_TEXT: '#797979',
  WHITE: '#fff',
  RED: '#ff0000',
  BLACK: '#000',
  BLACK_THREE: '#373737',
  RED_TWO: '#d34343',
  GREEN: '#32cd32',
  GREEN_TWO: '#97AE46',
  GREY_ELEVEN: '#777070',
  GREY_TWELVE: '#c3c3c3',
  BLACK_FOUR: '#333333',
  GRAPH_BLACK: '#212121',
  CHART_BLUE: '#00e2ff',
  WARNING: '#ffff00',
  GREY_DATA: '#696969',
  DISABLED_COLOR: '#889ccc',
  SUGGESTED_COLOR: '#00b7a0',
  PAGINATION_COLOR: '#fff',
  SELECTED_AREA: 'rgba(32, 177, 232, 0.6)',
  PRIMARY_BUTTON_TEXT: '#fff',
  USER_LOGO_COLOR: '#ffffff',
  SELECTED_MENU_TITLE: '#fff',
  SECONDARY_GRAY: '#a1a3a5',

  // Properties with fixed values (removed IS_ADMIN check)
  LOGOUT_ICON: '#fff',
  PRIMARY_MAIN: '#f0f2f2',
  SELECTED_MENU_BG: '#101820',
  PRIMARY_CONTRAST: '#000',
  PRIMARY_BORDER: '#adaeb0',
  NORMAL_LINK: '#455560',
  MODAL_HEADING: '#575757',
  MODAL_BACKGROUND: '#f0f2f2',
  LIST_TEXT: '#5e5f67',
  HEADER_LIST_TEXT: '#8a8a8a',
  SECONDARY_MAIN: '#F26F65',
  INPUT_BACKGROUND: '#ffffff',
  BACKGROUND: '#fff',
  SELECTED_TAB_COLOR: '#F26F65',
  LINK_COLOR: '#F26F65',
  RADIO_BACKGROUND: '#f0f2f2',
  FORM_COLOR: '#191e22',
  BODY_BACKGROUND: '#f0f2f2',
  CHECKBOX_TICK: '#F26F65',
  PAGINATION_BACKGROUND: '#fff',
  LOGIN_BUTTON: '#F26F65',
  TITLE_COLOR: '#191e22',
  INPUT_COLOR: '#000',
  INPUT_FOCUS: '#F26F65',
  TAB_LABEL: '#5e5f67',
  BACKGROUND_MENU: '#5e5f67',
  TABLE_ROW_COLOR: '#39434c',
  SORT_ICON: '#F26F65',
  LOGOUT_BUTTON: '#17181e',
  PAGINATION_HEADER: '#5e5f67',
  HEADER_TEXT: '#39434c',
  PAGINATION_BORDER: '#f0f2f2',
  RESET_BUTTON: '#2c2e33',
  ACTION_BORDER: '#5e5f67',
  FORM_INPUT_BG: '#f0f2f2',
  FORM_BACKGROUND: '#fff',
  CHECKBOX_BORDER: '#d1d3d6',
  SELECT_ACTIONS: '#444',
  SECONDARY_BORDER: '#d0d4d7',
  MULTISELECT_BACKGROUND: '#5e5f67',
  MULTISELECT_LABEL: '#f0f2f2',
  TAB_HIGHLIGHT: '#000',
  TAB_HIGHLIGHT_BACKGROUND: '#fff',
  ACCORDION_BACKGROUND: '#fff',
  TAB_BOTTOM_BORDER: '#F26F65',
  MENU_TITLE: '#fff',
  MENU_BORDER_COLOR: '#F26F65',
  MENU_BACKGROUND: '#636569',
  USER_LOGO_BACKGROUND: '#454c60',
  MAP: {
    LIGHT_BLACK: '#353740',
    LIGHTER_BLACK: '#353740',
    BLACK: '#353740',
    GREY: '#d1d1d1',
    LIGHT_GREY: '#d1d1d1',
    LIGHTER_GREY: '#d1d1d1',
    WATER: '#5e5f67',
    ROAD: '#37425C',
  },
  RANGE_PICKER: {
    CELL_BG: '#dfdfdf',
    CELL_HOVER_BG: '#bbbbbb',
  },
  LOGIN_HEAD_TEXT: '#000',
  HEADER_BG: '#101820',
  NEW_THEME: true,
  LIGHT_BORDER: '#2d2b2b',
  SECONDARY_CONTRAST: '#5e5f67',
  HEADER_COLOR: '#fff',
  DOCUMENT_LINE: '#2C3249',
  INPUT_BORDER: '#ccc',
  PAGINATION_ALTERNATE_BACKGROUND: '#f8f8f8',
  RESET_BACKGROUND: '#2c2e33',
  RESET_COLOR: '#ffffff',
  POLICIES_BACKGROUND: '#fff',
  LOGIN_BACKGROUND: '#fff',
};
export default colors;
export const fonts = IS_ADMIN ? ['Open Sans', 'sans-serif'].join(',') : ['NotoSans-Regular', 'sans-serif'].join(',');
